import React from 'react';
import './Spikes.css'

const Spikes = (props) => {
    return ( 
        <div className={props.SpikesStyle}>
            <img src={props.SpikesImg} alt="" />
        </div>
     );
}
 
export default Spikes;